import { render, staticRenderFns } from "./Case38.vue?vue&type=template&id=a9759710&scoped=true&"
import script from "./Case38.vue?vue&type=script&lang=js&"
export * from "./Case38.vue?vue&type=script&lang=js&"
import style0 from "./Case38.vue?vue&type=style&index=0&id=a9759710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9759710",
  null
  
)

export default component.exports